import { Component, Input, ViewChild } from '@angular/core';
import { NgOtpInputComponent } from 'ng-otp-input';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { MembersService } from 'src/app/shared/services/members.service';

@Component({
  selector: 'app-application-request-verification',
  templateUrl: './application-request-verification.component.html',
  styleUrls: ['./application-request-verification.component.scss'],
  standalone: false
})
export class ApplicationRequestVerificationComponent {
  verificationResult: string = '';
  @Input() expired: boolean = false;
  @Input() email: string = '';
  @Input() applicationId: string = '';
  config = {
    length: 6,
    allowNumbersOnly: true,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: ''
  };
  @Input() errorMessage: string | null = null; // Error message to display
  @ViewChild('ngOtpInput') ngOtpInputRef: NgOtpInputComponent;
  constructor(private membersService: MembersService) {}
  ngOnInit() {
    if (this.errorMessage) {
      this.expired = true;
    }
  }

  handleCodeChange(code: string): void {
    this.errorMessage = null;
    this.expired = false;
    if (code?.length === 6) {
      this.membersService
        .verifyVerificationCode(this.applicationId, code)
        .pipe(
          catchError((errorResponse) => {
            if (
              errorResponse.error &&
              errorResponse.status === 400 &&
              errorResponse.error.message
            ) {
              if (errorResponse.error.reason == 'Expired') {
                this.expired = true;
              }
              this.errorMessage = errorResponse.error.message;
            } else {
              this.errorMessage = 'Something went wrong! Please try again later..';
            }
            return of(null);
          })
        )
        .subscribe((data) => {
          if (data) {
            if (this.isValidUrl(data)) {
              window.location.href = data;
            }
          }
        });
    }
  }

  isValidUrl(str: string): boolean {
    try {
      new URL(str);
      return true;
    } catch (_) {
      return false;
    }
  }

  requestCode(): void {
    this.membersService
      .requestVerificationCode(this.applicationId, this.email)
      .pipe(
        catchError((errorResponse) => {
          if (errorResponse.error && errorResponse.status === 400 && errorResponse.error.message) {
            if (errorResponse.error.reason == 'Expired') {
              this.expired = true;
            }
            this.errorMessage = errorResponse.error.message;
          } else {
            this.errorMessage = 'Something went wrong! Please try again later..';
          }
          return of(null);
        })
      )
      .subscribe((data) => {
        if (data === true) {
          this.ngOtpInputRef.setValue(null);
          this.membersService.openSnackBar(
            'Enter the new code sent to the email. ' + this.email,
            true
          );
        }
      });
  }
}
